module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#video",
      toString: function () {
        return this.url;
      }
    }